exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-table{\r\n    width: 35%;\r\n    margin: 0 auto;\r\n\r\n}\r\n\r\n.custom-table td{\r\n    padding: 10px;\r\n    border: 1px solid black;\r\n    text-align:center;\r\n\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/cases-management-dashboard/cases-management-dashboard.component.css
// module id = 610
// module chunks = 0